module.exports = __webpack_public_path__ + "school/img/com.83f0462f.jpg";